import React, { useRef } from "react";

interface ImageGalleryProps {
  imagePaths: string[];
  onMiddleImageClick: () => void;
}

export default function ImageGallery({
  imagePaths,
  onMiddleImageClick,
}: ImageGalleryProps) {
  const middleClickCountRef = useRef(0);
  const clickTimeoutRef = useRef<number | null>(null);

  const handleMiddleClick = () => {
    const matterScene = document.querySelector(".matter-scene");

    if (!matterScene?.classList.contains("playing-false")) {
      // only allow if playing-false is present
      return;
    }

    middleClickCountRef.current += 1;
    if (clickTimeoutRef.current) clearTimeout(clickTimeoutRef.current);

    clickTimeoutRef.current = window.setTimeout(() => {
      middleClickCountRef.current = 0;
    }, 1500);

    if (middleClickCountRef.current >= 5) {
      middleClickCountRef.current = 0;
      onMiddleImageClick();
    }
  };

  return (
    <div className="images-container">
      {imagePaths.map((path, index) => (
        <div
          key={index}
          className="image"
          onClick={index === 2 ? handleMiddleClick : undefined}
          style={{ cursor: index === 2 ? "pointer" : "default" }}>
          <img src={path} alt={`item-${index}`} />
        </div>
      ))}
    </div>
  );
}
